// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatBot_container__3pVSb","chatBotWindow":"ChatBot_chatBotWindow__3cd8X","open":"ChatBot_open__1d6uG","chatbotLink":"ChatBot_chatbotLink__1_Fs2"};